
function inChinaIcpHost() {
  return window.location.host.indexOf('wamazing-cn.com') !== -1;
}

// Hack due to Rails setting: config.relative_url_root = '/snow'
function getImage(path) {
  return `/snow${path}`;
}

function getCountry() {
  if (inChinaIcpHost()) {
    return 'cn';
  }
  const subdomain = window.location.host.split('.')[0];
  if (subdomain === 'wamazing') {
    // Root domain
    return '';
  }
  return subdomain;
}

function getLocale({ underscore } = {}) {
  let locale = '';
  const subdomain = getCountry();
  switch (subdomain) {
    case 'www':
      locale = 'en'; break;
    case 'au':
      locale = 'en'; break;
    case 'jp':
      locale = 'ja'; break;
    case 'tw':
      locale = 'zh-TW'; break;
    case 'hk':
      locale = 'zh-HK'; break;
    case 'cn':
      locale = 'zh-CN'; break;
    default:
      locale = 'en';
  }
  if (underscore) {
    return locale.replace('-', '_').toLowerCase();
  }
  return locale;
}

/*
/snow/resorts/gala
/snow/resorts/gala/items
*/
function getResortUID(path) {
  const matched = path.match(/^\/snow\/resorts\/(\w+)/);
  if (!matched || !matched[1]) {
    return '';
  }
  return matched[1];
}

/*
/snow/items/217/orders
/snow/items/217/orders/new
/snow/items/217/orders/6adc2a70-3c6c-4b1d-b36f-00ca052fafed/thankyou
*/
function getSnowItemID(path) {
  const matched = path.match(/^\/snow\/items\/(\d+)/);
  if (!matched || !matched[1]) {
    return '';
  }
  return matched[1];
}

/*
/snow/items/217/orders/6adc2a70-3c6c-4b1d-b36f-00ca052fafed/thankyou
*/
function getOrderID(path, shorthand = true) {
  const matched = path.match(/^\/snow\/items\/\d+\/orders\/(.*)\/thankyou/);
  if (!matched || !matched[1]) {
    return '';
  }
  if (shorthand) {
    return matched[1].split('-')[0];
  }
  return matched[1];
}

/*
/snow/accommodations/lV74911/plans/3_15778370?resort_code=wamazing&xxx=xxx
/snow/accommodations/lV74911/plans/3_15778370/orders/389/thankyou
*/
function getAccommodationID(path) {
  const matched = path.match(/^\/snow\/accommodations\/(.+)\/plans\/(\w+)/);
  if (!matched || !matched[1]) {
    return '';
  }
  return matched[1];
}

function getAccommodationPlanID(path) {
  const matched = path.match(/^\/snow\/accommodations\/(.+)\/plans\/(\w+)/);
  if (!matched || !matched[2]) {
    return '';
  }
  return matched[2];
}

/*
/snow/accommodations/lV74911/plans/3_15778370/orders/389/thankyou
現在はホテル予約のみ OrderGroup が適応される
*/
function getOrderGroupID(path) {
  const matched = path.match(/^\/snow\/accommodations\/(.+)\/plans\/(.+)\/orders\/(\d+)\/thankyou/);
  if (!matched || !matched[3]) {
    return '';
  }
  return matched[3];
}

function getS3ImageUrl(path) {
  return `https://wa-snow-tokyo-production.s3-ap-northeast-1.amazonaws.com/app/images/${path}`;
};

export {
  inChinaIcpHost,
  getImage,
  getCountry,
  getLocale,
  getResortUID,
  getSnowItemID,
  getAccommodationID,
  getAccommodationPlanID,
  getOrderID,
  getOrderGroupID,
  getS3ImageUrl
};
